@if (posts && form) {
  <form [formGroup]="form">
    <div formGroupName="organisations" class="relationship__list">
      <div formArrayName="relationships">
        @for (item of relationships.controls; track item; let i = $index) {
          <div
            class="relationship__element"
            [formGroupName]="i"
            >
            <div class="row">
              <div class="col-6">
                <app-material-select2-autocomplete
                  formControlName="organisation_id"
                  [require]="true"
                  [placeholder]="'Название организации'"
                  [caption]="'Организация'"
                  [api_action]="'Organisation.search'">
                </app-material-select2-autocomplete>
              </div>
              <div class="col-6">
                <app-material-select2
                  formControlName="post_id"
                  [caption]="'Должность'"
                  [require]="true">
                  @for (post of posts; track post) {
                    <option [value]="post.post_id">
                      {{post.post_caption}}
                    </option>
                  }
                </app-material-select2>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </form>
}
<br>
  <button class="button button_sm" (click)="appendRelationship()">Добавить связь</button>
